import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, SvgIcon } from '@/components';
import useDevice from '@/hooks/useDevice';

import TransactionAlertsResetAllModal from '../TransactionAlertsResetAllModal/TransactionAlertsResetAllModal';
import styles from './TransactionAlertsSetDefault.module.sass';

interface TransactionAlertsSetDefaultProps {
  onReset: () => void;
}

const TransactionAlertsSetDefault = ({
  onReset,
}: TransactionAlertsSetDefaultProps) => {
  const { isMobile } = useDevice();
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOnClickButton = useCallback(() => setIsModalOpen(true), []);
  const handleOnClose = useCallback(() => setIsModalOpen(false), []);

  return (
    <>
      <Button
        size="s"
        type="secondary"
        corner="rect"
        className={styles.clearButton}
        onClick={handleOnClickButton}
      >
        {!isMobile && t('translation.reset_to_default')}
        {isMobile && <SvgIcon name="clear" />}
      </Button>

      <TransactionAlertsResetAllModal
        isOpen={isModalOpen}
        onReset={onReset}
        onClose={handleOnClose}
      />
    </>
  );
};

export default TransactionAlertsSetDefault;
